import { api } from 'shared';

export const createFeedback = async (email: string, name: string, phone: string, text: string) => (
    api.post(
        '/feedbacks',
        {
            data: {
                email,
                name,
                phone,
                text,
            },
        },
        {},
    )
);
